// extracted by mini-css-extract-plugin
export default {"imagecontainer":"styles_imagecontainer__GOaOc","image":"styles_image__CT5C2"};